import { DropDownPopupProps } from "type/addressType";
import { Button } from "./Button";
import { TextInput } from "./common/form/Input";
import { DropDownSelect } from "./common/form/Dropdown";
import Dropdown from "./common/form/SelectDropdown";
import { useState } from "react";
import ModalContainer from "./modal/Index";

export function DropDownPopup({
  setShowModal,
  showModal,
  setCurAddress,
  curAddress,
  handleAddressClick,
  masterState,
  loadingAddressProxy,
}: DropDownPopupProps): JSX.Element {
  const [searchState, setSearchState] = useState<string>("");

  const filteredStates = masterState?.filter((state) =>
    state.state.toLowerCase().includes(searchState.toLowerCase())
  );

  const isDisabled =
    !curAddress.address || !curAddress.city || !curAddress.state;

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string } }
  ) => {
    const { name, value } = e.target;
    setCurAddress({ ...curAddress, [name]: value });
  };

  return (
    <ModalContainer
      open={showModal}
      showCloseIcon={true}
      closeModal={() => setShowModal(false)}
      tailwindClassName={`w-[300px] sm:w-[600px] gap-4`}>
      <div className="w-full pt-10 pb-6 sm:px-8 p-4 rounded-lg text-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <TextInput
            type="number"
            label="House Number"
            isRequired
            name="houseNumber"
            className="border-2 rounded-lg placeholder:text-sm"
            onChange={handleChange}
            placeholder="Enter the house number"
          />

          <TextInput
            type="text"
            label="Street Name"
            isRequired
            name="address"
            className="border-2 rounded-lg placeholder:text-sm"
            onChange={handleChange}
            placeholder="Enter street name"
          />

          <TextInput
            type="text"
            label="City"
            isRequired
            name="city"
            className="border-2 rounded-lg placeholder:text-sm"
            onChange={handleChange}
            placeholder="Enter the city"
          />

          <div className="w-full">
            <div className="flex">
              <p className="text-[#4A564D] mb-2 text-sm leading-[20px] font-onestMedium">
                State
              </p>
              <span className="text-red-500 text-sm">*</span>
            </div>
            <Dropdown
              wholeContainerClass="!absolute left-0 right-0 sm:left-auto sm:right-auto sm:!w-[262px]"
              dropdownTriggerClassName="w-full px-4 sm:!px-0"
              search
              selectPlaceholderName="state"
              dropdownStateName={curAddress.state || "Select State"}
              dropdownValue={curAddress.state || ""}
              searchSubject={searchState}
              setSearchSubject={setSearchState}
              dropdownContainerClasses={`shadow-cardShadow-4 !w-full !right-0 border border-slate-100 rounded`}
              dropdownOptions={[
                {
                  customChild: (
                    <div>
                      <div>
                        {filteredStates?.map((stateItem: any, idx: number) => (
                          <div
                            key={idx}
                            onClick={() => {
                              handleChange({
                                target: {
                                  name: "state",
                                  value: stateItem.state,
                                },
                              });
                              setSearchState("");
                            }}>
                            <div className="px-3 py-2 text-sm font-onestMedium text-[#4a564d] hover:bg-[#edecec] cursor-pointer">
                              <p>{stateItem?.state}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </div>

        <div className="sm:mt-3 mt-12 mb-5">
          <DropDownSelect
            title="Country"
            lists={[{ id: "nigeria", name: "Nigeria" }]} // Example country list
            value={curAddress.country || "Nigeria"}
            handleOptionClick={(selectedCountry: any) =>
              handleChange({
                target: { name: "country", value: selectedCountry.name },
              })
            }
            placeholder="Select country"
            name="country"
          />
        </div>

        <Button
          title="Submit"
          type="button"
          disabled={isDisabled || loadingAddressProxy}
          onClick={() => {
            handleAddressClick(undefined, true);
            // setNoSuggest(false);
          }}
          loading={loadingAddressProxy}
          className={`col-start-2 !w-fit !px-12 justify-self-end ${
            isDisabled ? "bg-green-500/50" : ""
          }`}
        />
      </div>
    </ModalContainer>
  );
}
